angular.module('stack.common.i18n.localize.stackLocalize', [
  'stack.common.i18n.services.TranslationService'
])

/**
 * The Localize directive translates a string using a translator
 * service and injects it into the element.
 *
 * @class Localize
 * @constructor
 * @module stack.common.i18n.localize.stackLocalize
 * @example
 *   <div stack-localize="My Virtual Child">My Virtual Child</div>
 */
.directive('stackLocalize', [
  'TranslationService',
  function (TranslationService) {
    'use strict';

    return {
      restrict: 'EA',
      link: function (scope, element, attrs) {
        /**
         * Method injects translated token into the element DOM.
         *
         * @param {string} translated - Localized string to inject
         * @private
         */
        function inject(translated) {
          if (translated !== null && translated !== undefined && translated !== '') {
            if (typeof attrs.html !== 'undefined') {
              element.html(translated);
            } else {
              element.text(translated);
            }
          }
        }

        /**
         * Method checks translation service for token
         * and inserts it into DOM element.
         *
         * @param {string} token - Text to translate
         * @private
         */
        function translate(token) {
          TranslationService
            .translate(token)
            .then(inject)
            .catch(function (err) {
              console.log(err);
            });
        }

        /**
         * Method exectues the initialization process.
         *
         * @private
         */
        function initialize() {
          attrs.$observe('stackLocalize', function (token) {
            translate(token);
          });
        }
        initialize();
      }
    };
  }
]);
